import { defineMessages } from 'react-intl';

export const texts = defineMessages({
  createChannelError: {
    id: 'useCreateChannel.createChannelError',
    description: 'Create channel error',
    defaultMessage: 'Kunde inte skapa kanalen',
  },
});
